import axiosInstance from "./AxiosInstance";

// ✅ Example: GET request with params
export const fetchUserData = async (userId) => {
  try {
    const response = await axiosInstance.get(`api/users/profile`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user data:", error);
    throw error;
  }
};

// ✅ Example: POST request with body
export const getSubscription = async (postData) => {
  try {
    const response = await axiosInstance.get(`api/subscription/get`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user subscription:", error);
    throw error;
  }
};

export const connectWithGoogle = async (code) => {
  try {
    const response = await axiosInstance.post(`api/google/oauth/callback`, {
      code,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching user data:", error);
    throw error;
  }
};
